import React, { useMemo } from 'react'
import styled from 'particles/themes/styled'
import { theme } from 'theme'
import { useTranslation } from 'react-i18next'
import Text, { TextColor } from 'particles/Text'

export enum StatusType {
    NEW = 'New',
    VIEWED = 'Viewed',
}

interface StatusProps {
    className?: string
    type: StatusType
}
export const StatusCircle = styled.div<{ color: string }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ color }) => (color ? color : theme.newColors.neutral500)};
`

const Status: React.FC<StatusProps> = ({ className, type }) => {
    const [t] = useTranslation()
    const statusContext = useMemo(() => {
        switch (type) {
            case StatusType.NEW:
                return {
                    text: t('statusLabel.new'),
                    textColor: 'primary',
                    circleColor: theme.newColors.secondary300,
                }
            default:
                return {
                    text: t('statusLabel.viewed'),
                    textColor: 'primary',
                    circleColor: theme.newColors.neutral500,
                }
        }
    }, [type])

    return (
        <div className={className}>
            <StatusCircle color={statusContext.circleColor} />
            <Text scale="bodyM500" color={statusContext.textColor as TextColor}>
                {statusContext.text}
            </Text>
        </div>
    )
}

export default styled(Status)`
    display: flex;
    align-items: center;
    gap: 4px;
`
